<template>
  <div>
    <div class="back-to-home rounded d-none d-sm-block">
      <a href="https://brevisvelox.com" class="btn btn-icon btn-soft-primary"
        ><font-awesome-icon icon="home"
      /></a>
    </div>
    <section class="bg-home d-flex align-items-center">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-lg-6 col-md-5">
            <div class="mr-lg-5">
              <h3>
                <span class="text-success">Hvala!</span><br />Vprašalnik je
                zaključen.
              </h3>
              <img
                src="@/assets/images/illustrator/Asset189.svg"
                class="img-fluid d-block mx-auto"
                alt=""
              />
            </div>
          </div>
          <div class="col-lg-6 col-md-7">
            <div class="card login_page  border-0">
              <div class="card-body" v-html="currentPackage.finish_text"></div>
            </div>
            <div class="my-3 p-3 border border-primary rounded">
              <h4 class="text-muted mb-3">
                Želite biti obveščeni o novih aktivnih raziskavah?
              </h4>
              <p class="text-muted">
                Vpišite svoj emil naslov in obvestili vas bomo o novih
                raziskavi, kjer boste lahko izbrali dobrodelno društvo, ki mu
                bomo donirali sredstva. <br /><br />Prijava je anonimna in ni
                nikakor povezana z vašimi odgovori iz raziskave.
              </p>
              <form
                action="https://brevisvelox.us5.list-manage.com/subscribe/post?u=baf2e92589d5e24d9115308f2&amp;id=a5054992f7"
                method="post"
                id="mc-embedded-subscribe-form"
                name="mc-embedded-subscribe-form"
                class="validate"
                target="_blank"
                novalidate
              >
                <div class="input-group">
                  <input
                    type="email"
                    value=""
                    name="EMAIL"
                    class="form-control"
                    id="mce-EMAIL"
                    placeholder="Vaš email naslov "
                    required
                  />
                  <div class="input-group-append">
                    <input
                      type="submit"
                      value="Prijavite se na obvestila"
                      name="subscribe"
                      id="mc-embedded-subscribe"
                      class="btn btn-sm btn-success rounded-right"
                    />
                  </div>
                  <!-- real people should not fill this in and expect good things - do not remove this or risk form bot signups-->
                  <div
                    style="position: absolute; left: -5000px;"
                    aria-hidden="true"
                  >
                    <input
                      type="text"
                      name="b_baf2e92589d5e24d9115308f2_a5054992f7"
                      tabindex="-1"
                      value=""
                    />
                  </div>
                </div>
              </form>
            </div>
          </div>
          <!--end col-->
        </div>
        <!--end row-->
      </div>
      <!--end container-->
    </section>
    <!--end section-->
  </div>
</template>
<script>
import { mapGetters } from "vuex";

import moment from "moment";
moment.locale("en");
export default {
  components: {},
  data() {
    return {
      projectSlug: this.$route.params.projectSlug,
    };
  },
  computed: {
    ...mapGetters({
      currentPackage: "api/getCurrentPackage",
    }),
  },

  created() {},
  mounted() {
    this.$gtm.trackEvent({
      event: "package.finish",
      label: "Package finished",
      noninteraction: true,
    });
  },
  methods: {
    resetQuiz: function() {
      if (this.project.sequences) {
        if (
          this.project.custom_order &&
          this.currentSequenceOrder === this.projectSequences + 1
        ) {
          this.$store.commit("api/quizResetProgress");
          this.$store.commit("api/quizResetSequence");
        } else {
          this.$store.commit("api/quizResetProgress");
          this.$store.commit("api/resetMatchupOrder");
          this.$store.dispatch(
            "api/fetchRandomSequencesMatchups",
            this.project.random_slug
          );
        }
      } else {
        this.$store.commit("api/quizResetProgress");
      }

      this.$router.push({
        name: "Matchup",
        params: { projectSlug: this.projectSlug },
      });
    },
  },
};
</script>
